'use strict'
import { getAircraft, getCityName } from '../util/helpers.js';
import { formatTime, formatConnectionTime } from '../util/formats.js';

// FlightDetails.js - collapsable flight details module
class FlightDetails {
    constructor(id, slice, bound, data) {
        this.id = id;
        this.data = data;
        this.slice = slice;
        this.bound = bound;
		this.aircrafts = data.body.trips.data.aircraft;
        
        this.getCarbon = this.getCarbon.bind(this);
        this.getFlightDetails = this.getFlightDetails.bind(this);
        this.getFlightSegment = this.getFlightSegment.bind(this);
        this.getFlightDiagram = this.getFlightDiagram.bind(this);
        this.generatePlaneIcons = this.generatePlaneIcons.bind(this);
    }

    getFlightDiagram(i) {
        // Create the elements within the large flight details diagram div
        const origin = this.slice.segment[i].leg[0].origin;
        const destination = this.slice.segment[i].leg[0].destination;
        const departureTime = this.slice.segment[i].leg[0].departureTime;
        const arrivalTime = this.slice.segment[i].leg[0].arrivalTime;

        return `
            <div class='flight-diagram-details'>
                <div class='flight-diagram-info'>
                    <h2 class='flight-diagram-info-text'> ${origin} </h2>
                    <p class='flight-diagram-info-text' style='font-size: 11px'>
                        ${getCityName(origin, this.data)}
                    </p>
                    <hr class='flight-hr'/>
                    <p class='flight-diagram-info-text'> ${formatTime(departureTime).time} </p>
                    <p class='flight-diagram-info-text' style='font-size:12px'>${formatTime(departureTime).date}</p>
                </div>

                <img class='flight-diagram-arrow' src='../../assets/images/arrow.svg' alt=''/>

                <div class='flight-diagram-info'>
                    <h2 class='flight-diagram-info-text'> ${destination} </h2>
                    <p class='flight-diagram-info-text' style='font-size: 11px'>
                        ${getCityName(destination, this.data)}
                    </p>
                    <hr class='flight-hr'/>
                    <p class='flight-diagram-info-text'> ${formatTime(arrivalTime).time} </p>
                    <p class='flight-diagram-info-text' style='font-size:12px'>${formatTime(arrivalTime).date}</p>
                </div>
            </div>
        `;
    }

    getCarbon(i) {
		// let distance = Math.round(this.slice.segment[i].distance);
		let carbonAmount = Math.round(this.slice.segment[i].carbon);
        return `
            <div class='carbon-value carbon-${this.id}'>
                ${carbonAmount || '?'} kg CO<sub>2</sub>
            </div>
        `
    }

    generatePlaneIcons(flightSegmentOrder, planeOrder) {
        let icon = document.createElement('img');
        const iconBaseSrc = '../../assets/images/plane';
        const iconSrc = (flightSegmentOrder === planeOrder) ?
            `${iconBaseSrc}-black-${this.bound}.png` : `${iconBaseSrc}-grey-${this.bound}.png`;

        return `<img src='${iconSrc}' class='airplane-icon'>`;
    }

    getFlightSegment(i) {
        let flightNumber = this.slice.segment[i].flight.number;
        let aircraftCode = this.slice.segment[i].leg[0].aircraft;
        let carrierCode = this.slice.segment[i].flight.carrier;
        const segment = this.slice.segment;

        return `
            <div class='oneway-details'>

                <div class='small-logo'><img src="https://pics.avs.io/150/50/${carrierCode}@2x.png" style="border:0px solid rgb(243,243,243); width:110px;"></div>
                ${this.bound === 'out' ? `
                    ${segment.map((e, j) => this.generatePlaneIcons(i, j)).join('\n')}
                ` : `
                    ${segment.map((e, j) => this.generatePlaneIcons(i, j)).reverse().join('\n')}
                `}
                </br>
                <div class='small-details-text' style='font-size: 12px;'>
                    ${carrierCode} ${flightNumber}
                </div>
                <div class='small-details-text' style='font-size: 9px; color: black;'>
                    ${getAircraft(aircraftCode, this.data)}
                </div>
                <div class='small-details-text' style='font-size: 9px; color: gray;'>
                    (${aircraftCode})
                </div>
            </div>
        `;
    }

    getFlightDetails() {
        // Create the container for the flight details (bound is 'in' or 'out')
        return `
            <div id='result-details-${this.bound}-${this.id}' class='oneway-details-container'>
                <div class='trip-title'>
                    ${(this.bound === 'out') ? 'Departure Trip' : 'Return Trip'}
                </div>

                ${this.slice.segment.map((e, i) =>
                    `
                    <div class='oneway-flight-details'>
                        ${this.getCarbon(i)}
                        ${this.getFlightSegment(i)}
                        ${this.getFlightDiagram(i)}
                    </div>

                    ${this.slice.segment[i].connectionDuration ? `
                        <div class='connection-time'>
                            <i class='icon ion-ios-clock-outline'></i>
                            Connection Time: ${formatConnectionTime(this.slice.segment[i].connectionDuration)}
                        </div>
                    ` : ''}
                    `
                ).join('\n')}
            </div>
        `
    }
}

export default FlightDetails



// WEBPACK FOOTER //
// ./components/FlightDetails.js